<template lang="pug">
section.card_container.gray-bg.py-5
  .container
    .row
      .col-lg-4.mb-4(v-for="courseType in coureseTypes", :key="courseType.id")
        .card.home-camp-card
          img.card-img-top(
            v-if="courseType.photo",
            :src="courseType.photo.image"
          )
          .card-body.position-relative
            h5.card-title
              img.top-basketball-icon(
                src="@/assets/img/icons/icon_small_basketball.png"
              )
              span.icon-title {{ courseType.name }}
            p.card-text {{ courseType.title }}
            .btn.strength-btn(@click="readMoreClick(courseType.id)") 了解更多
</template>

<script>
import "@/assets/style/main.scss";
import { getCourseTypeList } from "@/api/web_content";

export default {
  name: "Cards",
  data() {
    return {
      coureseTypes: [],
    };
  },
  created() {
    this.getCourseTypes();
  },
  methods: {
    getCourseTypes() {
      getCourseTypeList().then((response) => {
        this.coureseTypes = response.data;
      });
    },
    readMoreClick(courseTypeId) {
      this.$router.push({
        name: "CourseIntroDetail",
        query: { id: courseTypeId },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/home/cards";
</style>
